import { Expose, Transform, TransformPlainToClass } from 'class-transformer';

import { SnContentType } from '@lib/api/entities';
import { ExposeFunction, ExposeRawData } from '@lib/common/decorators';
import { SnAvatar } from '@lib/ui/avatar';
import { SnIcon } from '@lib/ui/icon';

import { SnSearchbarOptionClickHandler, SnSearchbarOptionConfig } from '../types';

export class SnSearchbarOption {
  @Expose()
  public readonly label: string;

  @Expose()
  public readonly value: string;

  @Expose()
  public readonly isLabel: boolean;

  @Expose()
  public readonly secondaryLabel: string;

  @Expose()
  @ExposeRawData()
  public readonly attributes?: any;

  @Expose()
  @ExposeRawData()
  public readonly contentType?: SnContentType;

  @Expose()
  @Transform((value, data) => SnIcon.fromConfig(data.icon))
  public readonly icon: SnIcon;

  @Expose()
  @Transform((value, data) => SnAvatar.fromConfig(data.avatar))
  public readonly avatar: SnAvatar;

  @ExposeFunction()
  public readonly click: SnSearchbarOptionClickHandler;

  @TransformPlainToClass(SnSearchbarOption, { strategy: 'excludeAll' })
  public static fromConfig(config: SnSearchbarOptionConfig): SnSearchbarOption {
    const data = typeof config === 'string' ? { label: config, value: config } : config;

    return data as SnSearchbarOption;
  }

  // FIXME fix transforming config to searchbar option
  private get data(): SnSearchbarOption {
    return this;
  }
}
